/*!

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/ 
// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import Person from "@material-ui/icons/Person";
// core components/views for Admin layout
import LDAPage from "views/Dashboard/LDA.js";
import Lebeling from "views/Labeling/Labeling";
// core components/views for RTL layout
import TableList from "views/users/users.js";
import TrainLda from "views/TrainLda/TrainLda.js";
import AddArticles from "views/AddArticles/AddArticles.js";
import StopWords from "views/StopWords/StopWords.js"
import FindSimilar from "views/FindSimilar/FindSimilar.js"
import ArticlesInformation from "views/ArticlesInformation/ArticlesInformation.js"
import ArticlesInformation2 from "views/ArticlesInformation2/ArticlesInformation2.js"
var dashboardRoutes = [
  {
    path: "/lda",
    name: "LDA",
    rtlName : "تحلیل موضوعی متن",
    icon: Dashboard,
    component: LDAPage,
    layout: "/dashboard"
  },
  {
    path: "/table",
    name: "Table List",
    rtlName: "لیست کاربران",
    icon: Person,
    component: TableList,
    layout: "/dashboard"
  },
  {
    path: "/train_lda",
    name: "Table List",
    rtlName: "آموزش مدل",
    icon: Dashboard,
    component: TrainLda,
    layout: "/dashboard"
  }, 
  {
    path: "/labeling",
    name: "labeling",
    rtlName: "برچسب‌گذاری",
    icon: Dashboard,
    component: Lebeling,
    layout: "/dashboard"
  },
  {
    path: "/add_articles",
    name: "add article",
    rtlName: "اضافه کردن داده",
    icon: Dashboard,
    component: AddArticles,
    layout: "/dashboard"
  },
  {
    path: "/stop_words",
    name: "stopwords list",
    rtlName: "ایست واژه‌ها",
    icon: Dashboard,
    component: StopWords,
    layout: "/dashboard"
  },
  {
    path: "/similar_articles",
    name: "similar articles",
    rtlName: "استخراج مقالات مشابه",
    icon: Dashboard,
    component: FindSimilar,
    layout: "/dashboard"
  },
  {
    path: "/articles_information",
    name: "information",
    rtlName: "اطلاعات آماری مستندات",
    icon: Dashboard,
    component: ArticlesInformation,
    layout: "/dashboard"
  },
  {
    path: "/complete_articles_information",
    name: "information_complete",
    //rtlName: "اطلاعات آماری برچسب‌ها",
    // rtlName: "2",
    icon:"",// Dashboard,
    component: ArticlesInformation2,
    layout: "/dashboard"
  },
];

export default dashboardRoutes;
